import { render, staticRenderFns } from "./Glasses.vue?vue&type=template&id=9f60e0f4&"
import script from "./Glasses.vue?vue&type=script&lang=js&"
export * from "./Glasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports